import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ListboxModule } from 'primeng/listbox';
import { TableModule } from 'primeng/table';
import { FormgenModule } from '../../libraries/formgen/formgen.module';
import { LibrariesModule } from '../../libraries/libraries.module';
import { SharedModule } from '../../libraries/shared.module';
import { LocationCreateComponent } from './create/location-create.component';
import { LocationFormComponent } from './form/location-form.component';
import { LocationListComponent } from './list/location-list.component';
import { LocationRestService } from './location-rest.service';
import { LocationRoutingModule } from './location-routing.module';
import { LocationUpdateComponent } from './update/location-update.component';

export const PROVIDERS = [LocationRestService];

@NgModule({
  imports: [
    LocationRoutingModule,
    BsDropdownModule,
    CommonModule,
    FlexLayoutModule,
    FormgenModule,
    FormsModule,
    ListboxModule,
    LibrariesModule,
    PaginationModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    TableModule,
    TranslateModule
  ],
  declarations: [
    LocationCreateComponent,
    LocationFormComponent,
    LocationListComponent,
    LocationUpdateComponent
  ]
})
export class LocationModule {}
